import Immutable from "immutable";
import { COLLECTION_SHAPE } from "../../../config/shapes";
import {
  FLAG_GETTING_MAINTENANCE_BUS_FLEETS,
  GET_MAINTENANCE_BUS_FLEETS,
  CLEAR_MAINTENANCE_BUS_FLEETS,
  GET_MAINTENANCE_BUS_FLEET,
  CLEAR_MAINTENANCE_BUS_FLEET,
  FLAG_GETTING_MAINTENANCE_BUS_FLEET,
  GET_HISTORY_OF_BUS_MAINTENANCE_STAY,
  CLEAR_HISTORY_OF_BUS_MAINTENANCE_STAY,
  FLAG_GETTING_HISTORY_OF_BUS_MAINTENANCE_STAY
} from "../../../actions/types";

const INITIAL_STATE = Immutable.Map({
  all: Immutable.Map({
    content: Immutable.Map(COLLECTION_SHAPE),
    loading: false,
  }),
  current: Immutable.Map({
    content: Immutable.Map(),
    activity: Immutable.List(),
  }),
  historyOfBusMaintenanceStay: Immutable.Map({
    content: Immutable.List(),
    loading: false,
  }),
});


export default (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case FLAG_GETTING_MAINTENANCE_BUS_FLEETS:
      return state.setIn(['all', 'loading'], payload);
    case GET_MAINTENANCE_BUS_FLEETS:
      return state.setIn(['all', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_BUS_FLEETS:
      return state.setIn(
        ['all', 'content'],
        INITIAL_STATE.getIn(['all', 'content']),
      );
    case FLAG_GETTING_MAINTENANCE_BUS_FLEET:
      return state.setIn(['current', 'loading'], payload);
    case GET_MAINTENANCE_BUS_FLEET:
      return state.setIn(['current', 'content'], Immutable.Map(payload));
    case CLEAR_MAINTENANCE_BUS_FLEET:
      return state.setIn(
        ['current', 'content'],
        INITIAL_STATE.getIn(['current', 'content']),
      );

    case FLAG_GETTING_HISTORY_OF_BUS_MAINTENANCE_STAY:
      return state.setIn(['historyOfBusMaintenanceStay', 'loading'], payload);
    case GET_HISTORY_OF_BUS_MAINTENANCE_STAY:
      return state.setIn(['historyOfBusMaintenanceStay', 'content'], Immutable.List(payload));
    case CLEAR_HISTORY_OF_BUS_MAINTENANCE_STAY:
      return state.setIn(
        ['historyOfBusMaintenanceStay', 'content'],
        INITIAL_STATE.getIn(['historyOfBusMaintenanceStay', 'content']),
      );
    default:
      return state;
  }
}
